import { baseApi } from '@shared/api/baseApi';
export type SellingType = 'DIGITAL';
export interface ShopDetails {
  name: string;
  slug: string;
  description: string;
  sellingTypes: SellingType[];
  contactEmail?: string | null;
  contactPhone?: string | null;
  location?: string | null;
  returnPolicy?: string | null;
  fulfillmentPolicy?: string | null;
}
export interface ShopDto extends ShopDetails {
  id: string;
  status: 'DRAFT' | 'PENDING_VERIFICATION' | 'ACTIVE' | 'SUSPENDED' | 'CLOSED';
  acceptingOrders: boolean;
  isPlatformShop: boolean;
  logoUrl: string | null;
  bannerUrl: string | null;
}
const shopApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicShop: builder.query<ShopDto, string>({
      query: (slug) => `/shops/${encodeURIComponent(slug)}`,
      transformResponse: (response: { shop: ShopDto }) => response.shop,
      providesTags: ['SellerShop'],
    }),
    getMyShops: builder.query<ShopDto[], void>({
      query: () => '/seller/shops',
      transformResponse: (response: { shops: ShopDto[] }) => response.shops,
      providesTags: ['SellerShop'],
    }),
    createShop: builder.mutation<{ shop: ShopDto }, ShopDetails>({
      query: (body) => ({ url: '/seller/shops', method: 'POST', body }), invalidatesTags: ['SellerShop'],
    }),
    updateShop: builder.mutation<{ shop: ShopDto }, { id: string; details: Partial<ShopDetails> }>({
      query: ({ id, details }) => ({ url: `/seller/shops/${id}`, method: 'PATCH', body: details }), invalidatesTags: ['SellerShop'],
    }),
    uploadShopBranding: builder.mutation<{ shop: ShopDto }, { id: string; kind: 'logo' | 'banner'; content: string }>({
      query: ({ id, kind, content }) => ({ url: `/seller/shops/${id}/branding/${kind}`, method: 'PUT', body: { content } }), invalidatesTags: ['SellerShop'],
    }),
  }),
});
export const { useGetPublicShopQuery, useGetMyShopsQuery, useCreateShopMutation, useUpdateShopMutation, useUploadShopBrandingMutation } = shopApi;
